// External dependencies
import 'jquery';

// Internal dependencies
import Router from './util/Router';

// Common for all routes
import common from './routes/common';

// WooCommerce routes
import WooCommerceSingleProduct from './routes/woocommerce-single-product';
import WooCommerceProductCategory from './routes/woocommerce-product-category';
import WooCommerceCart from './routes/woocommerce-cart';
import WooCommerceCheckout from './routes/woocommerce-checkout';
import WooCommerceAccount from './routes/woocommerce-account';
import WooCommerceShop from './routes/woocommerce-shop';

// WordPress routes
import SinglePage from './routes/single-page';
import SingleMember from './routes/single-member';
import TemplateHome from './routes/template-home';
import Error404 from './routes/404';
import TemplateCookies from './routes/template-cookies';
import TemplateContact from './routes/template-contact';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // WooCommerce pages
  singleProduct: WooCommerceSingleProduct,
  taxProductCat: WooCommerceProductCategory,
  woocommerceCart: WooCommerceCart,
  woocommerceCheckout: WooCommerceCheckout,
  woocommerceAccount: WooCommerceAccount,
  woocommerceShop: WooCommerceShop,

  // WordPress templates
  templateHome: TemplateHome,
  templateCookies: TemplateCookies,
  templateContact: TemplateContact,
  singleMember: SingleMember,
  singlePage: SinglePage,

  // Other
  error404: Error404,
});

// Load Events
$(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js